import { Node as ReactFlowNode } from '@xyflow/react';
import { useCallback } from 'react';

import { useFlowChartContext } from '../../context/flowChart.context';
import { InternalFlowChartProps, Node } from '../../types';

/**
 * @description Wrapper around node drag stop to set our drop target to null or the target
 */
export function useInternalOnNodeDragStop<T extends ReactFlowNode = Node>({
  onNodeDragStop: onNodeDragStopProp,
}: InternalFlowChartProps<T>): InternalFlowChartProps<T>['onNodeDragStop'] {
  const {
    __internal: { setDropTargetNode },
  } = useFlowChartContext();
  const onNodeDragStop = useCallback<
    NonNullable<InternalFlowChartProps<T>['onNodeDragStop']>
  >(
    (...args) => {
      setDropTargetNode(null);
      onNodeDragStopProp?.(...args);
    },
    [onNodeDragStopProp, setDropTargetNode]
  );

  return onNodeDragStop;
}
